export default __webpack_public_path__ + "static/media/ilustracao-mulher-apresentando-duvidas-frequentes.f5364121.svg";